import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import {
  AbstractSecurityStorage,
  authInterceptor,
  DefaultLocalStorageService,
  provideAuth
} from 'angular-auth-oidc-client';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { loaderInterceptor } from '@core/interceptors/loader';
import { permissionErrorInterceptor } from '@core/interceptors/permission-error';
import { SessionExpiryService } from '@core/services/session-expiry';
import { environment } from '@src/environments/environment';

import { routes } from './app.routes';
import { materialPreset } from './prime-preset/material-preset';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor(), loaderInterceptor, permissionErrorInterceptor])),
    provideAuth(environment.authConfig),
    // Start listening for silent-renew failures before anything can expire.
    provideAppInitializer(() => inject(SessionExpiryService).init()),
    // Persist OIDC tokens across tabs and full page loads (default session storage drops them).
    { provide: AbstractSecurityStorage, useClass: DefaultLocalStorageService },
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: materialPreset,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-theme'
        }
      },
      ripple: true
    }),
    MessageService,
    ConfirmationService
  ]
};
